import React from 'react';

const Footer = () => {

    return (
        <footer>
            <p>© 
                <a href="https://github.com/sophiakim1" className="name"> Sophia</a> at
                <a href="https://junocollege.com/" className="name"> Juno College</a>
            </p>
        </footer>
    );
};

export default Footer;